import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    dropdown: {
        boxShadow: theme.shadows.xl,
        height: "30.25rem",
        padding: "0",
    },
}))
